import React, { useMemo } from 'react';
import locales from '../../../../../content.json';
import { getParameterFromURL } from '../../../../../utils/scripts';
import s from './index.module.scss';
import zone from './img/zone.png';
import zoneDark from './img/zoneDark.png';

export const Description = () => {
  const role = getParameterFromURL('role');
  const darkTheme = getParameterFromURL('darkTheme');

  const list2 = useMemo(() => {
    if (role === 'puppy') {
      return (
        <ul className={s.list2}>
          <li>{locales[window.userLang].pdfUpselling_9}</li>
          <li>{locales[window.userLang].pdfUpselling_10}</li>
          <li>{locales[window.userLang].pdfUpselling_11}</li>
          <li>{locales[window.userLang].pdfUpselling_12}</li>
        </ul>
      )
    } else {
      return (
        <ul className={s.list2}>
          <li>{locales[window.userLang].pdfUpselling_5}</li>
          <li>{locales[window.userLang].pdfUpselling_6}</li>
          <li>{locales[window.userLang].pdfUpselling_7}</li>
          <li>{locales[window.userLang].pdfUpselling_8}</li>
        </ul>
      )
    }
  }, [role]);

  return (
    <div className={s.wrapper}>
      <ul className={s.list}>
        <li className={s.item1} dangerouslySetInnerHTML={{ __html: locales[window.userLang].pdfUpselling_3}} />
        <li className={s.item2} dangerouslySetInnerHTML={{ __html: locales[window.userLang].pdfUpselling_4}} />
        <li>
          {list2}
        </li>
        <img className={s.listImg} src={darkTheme ? zoneDark : zone}  alt="" />
      </ul>

    </div>
  )
}